<template>
    <div>
        <div class="login">
            <div id='okta-signin-container'></div>
        </div>
        <div class="forgot-password-link">
            <a id="forgotPasswordAnchor" href="#" @click="forgotPasswordLink">{{forgotPassLinkText}}</a>
        </div>
        <div style="display:flex;justify-content:flex-end;">
            <div class="v-text-toggle__suffix" id="showPasswordDiv" @click="togglePassword">{{hidePasswordText}}</div>
        </div>
    </div>
</template>

<script>
import {AuthenticationService} from '@nuskin/ns-account';
import {ConfigService, cookieUtil} from '@nuskin/ns-util';
import OktaSignIn from '@okta/okta-signin-widget';
import sampleConfig from '../config';

export default {
    name: 'OktaLogin',
    props: {
        usernameLabel: {
            type: String,
            default: 'Username (Email Address)'
        },
        logInBtnText: {
            type: String,
            default: 'Sign In'
        },
        loginFormErrorMsg: {
            type: String,
            default: 'Sorry there was a problem getting you logged in.'
        },
        forgotPassLinkText: {
            type: String,
            default: 'Forgot Password'
        },
        passwordLabel: {
            type: String,
            default: 'Password'
        },
        passwordShowText: {
            type: String,
            default: 'Show'
        },
        passwordHideText: {
            type: String,
            default: 'Hide'
        },
        sendMfaCodeBtnText: {
            type: String,
            default: 'Send me the code'
        },
        signoutLinkText: {
            type: String,
            default: 'Sign Out'
        },
        mfaEmailSentMsg: {
            type: String,
            default: 'A verification code was sent to {0}. Check your email and enter the code below.'
        },
        mfaEmailNotReceivedMsg: {
            type: String,
            default: 'Haven\'t received an email?'
        },
        resendMfaEmailLinkTxt: {
            type: String,
            default: 'Send again'
        },
        verifyMfaBtnTxt: {
            type: String,
            default: 'Verify'
        },
        formErrorMsg: {
            type: String,
            default: 'We found some errors. Please review the form and make corrections.'
        },
        blankFieldErrorMsg: {
            type: String,
            default: 'This field cannot be left blank'
        },
        mfaVerificationCodeLabel: {
            type: String,
            default: 'Verification code'
        },
        sendMfaVerificationCodeMsg: {
            type: String,
            default: 'Send a verification code to {0}'
        },
        nextBtnTxt: {
            type: String,
            default: 'Next'
        },
        updateValueCallback: {
            type: Function
        },
        gigyaLogin: {
            type: Function
        },
        loginerror: {
            type: Boolean,
            default: false
        },
        setUsername: {
            type: Function
        },
        setPassword: {
            type: Function
        },
        toggleWidget: {
            type: Function
        },
        enableMfa: {
            type: Boolean,
            default: false
        },
        language: {
            type: String,
            default: 'en'
        }
    },
    data() {
        return {
            hidePasswordText: '',
            tryGigya: true,
            hidePassword: true,
            loginTranslations: {}
        };
    },
    watch: {
        loginerror(val) {
            if (val === true) {
                this.handleOnError();
            }
        }
    },
    methods: {
        setTranslations() {
            console.log('setting translations');
            this.loginTranslations = window.loginTranslations;
            this.loginFormErrorMsg = this.loginTranslations.loginFormErrorMsg || this.loginFormErrorMsg;
            this.passwordLabel = this.loginTranslations.passwordLabel || this.passwordLabel;
            this.logInBtnText = this.loginTranslations.logInBtnText || this.logInBtnText;
            this.hidePasswordText = this.loginTranslations.passwordShowText || this.passwordShowText;
            this.usernameLabel = this.loginTranslations.usernameLabel || this.usernameLabel;
            this.forgotPassLinkText = this.loginTranslations.forgotPassLinkText || this.forgotPassLinkText;
            this.hidePasswordText = this.loginTranslations.passwordShowText || this.hidePasswordText;
            this.sendMfaCodeBtnText = this.loginTranslations.sendMfaCodeBtnText || this.sendMfaCodeBtnText;
            this.signoutLinkText = this.loginTranslations.signoutLinkText || this.signoutLinkText;
            this.mfaEmailNotReceivedMsg = this.loginTranslations.mfaEmailNotReceivedMsg || this.mfaEmailNotReceivedMsg;
            this.resendMfaEmailLinkTxt = this.loginTranslations.resendMfaEmailLinkTxt || this.resendMfaEmailLinkTxt;
            this.verifyMfaBtnTxt = this.loginTranslations.verifyMfaBtnTxt || this.verifyMfaBtnTxt;
            this.formErrorMsg = this.loginTranslations.formErrorMsg || this.formErrorMsg;
            this.blankFieldErrorMsg = this.loginTranslations.blankFieldErrorMsg || this.blankFieldErrorMsg;
            this.mfaVerificationCodeLabel = this.loginTranslations.mfaVerificationCodeLabel || this.mfaVerificationCodeLabel;
            this.sendMfaVerificationCodeMsg = this.loginTranslations.sendMfaVerificationCodeMsg || this.sendMfaVerificationCodeMsg;
            this.mfaEmailSentMsg = this.loginTranslations.mfaEmailSentMsg || this.mfaEmailSentMsg;
            this.nextBtnTxt = this.loginTranslations.nextBtnTxt || this.nextBtnTxt;
        },
        forgotPasswordLink() {
            this.$router.push({
                name: 'forgot-password'
            });
        },
        togglePassword(event) {
        // const loginTranslations = window.loginTranslations;
            this.hidePassword = !this.hidePassword;
            if (this.hidePassword) {
                this.hidePasswordText = this.loginTranslations.passwordShowText || this.passwordShowText;
                document.querySelector('[name="password"]').type = 'password';
            } else {
                this.hidePasswordText = this.loginTranslations.passwordHideText || this.passwordHideText;
                document.querySelector('[name="password"]').type = 'text';
            }
        },
        initGigyaLogin() {
            const errorElement = document.getElementsByClassName('okta-form-input-error')[0] || document.getElementsByClassName('okta-form-infobox-error')[0];
            if (errorElement) {
                errorElement.style.Display = 'none';
            }

            const password = (document.querySelector('[name="password"]') || {}).value;
            this.setPassword(password);
            this.toggleWidget(false);
            this.gigyaLogin();
        },
        handleOnError() {
            this.loginerror = true;
        },
        removeAutocomplete() {
            document.querySelector('[name="username"]').removeAttribute('autocomplete');
            document.querySelector('[name="password"]').removeAttribute('autocomplete');
        },
        async handleLogin(res) {
            this.updateValueCallback('processing', true);
            const data = {
                accessToken: res.tokens.accessToken.value,
                idToken: res.tokens.idToken.value
            };
            await AuthenticationService.oktaLogin(data);
        }
    },


    created() {
        this.setTranslations();
    },
    async mounted() {
        const self = this;
        await this.$features.$waitForLoad();

        if (
            typeof window.loginPageConfig.language != 'undefined' &&
            window.loginPageConfig.language
        ) {
            this.language = window.loginPageConfig.language;
        }

        this.tryGigya = !this.$features['cx107-login-cutover'];

        if (this.$features['cx107-477-all-markets-okta-widget-mfa'] || cookieUtil.getCookie('oktaEnableMfa')) {
            this.enableMfa = true;
        } else if (this.$features['cx107-477-market-based-okta-widget-mfa']) {
            this.enableMfa = ConfigService.getMarketConfig().enableOktaMfaFlow;
        }

        this.$nextTick(function() {
            self.widget = new OktaSignIn({
                baseUrl: sampleConfig.oidc.issuer.split('/oauth2')[0],
                clientId: sampleConfig.oidc.clientId,
                redirectUri: sampleConfig.oidc.redirectUri,
                language: self.language,
                i18n: {
                    en: {
                        'primaryauth.username.placeholder': self.usernameLabel,
                        'primaryauth.password.placeholder': self.passwordLabel,
                        'primaryauth.submit': self.logInBtnText,
                        'error.username.required': window.loginTranslations.forgotPassError,
                        'error.password.required': window.loginTranslations.resetPassInputError,
                        'email.button.send': self.sendMfaCodeBtnText,
                        'signout': self.signoutLinkText,
                        'email.code.not.received': self.mfaEmailNotReceivedMsg,
                        'email.button.resend': self.resendMfaEmailLinkTxt,
                        'oform.verify': self.verifyMfaBtnTxt,
                        'oform.errorbanner.title': self.formErrorMsg,
                        'model.validation.field.blank': self.blankFieldErrorMsg,
                        'email.code.label': self.mfaVerificationCodeLabel,
                        'email.mfa.description': self.sendMfaVerificationCodeMsg,
                        'oform.next': self.nextBtnTxt,
                        'email.mfa.email.sent.description': self.mfaEmailSentMsg
                    }
                },

                authParams: {
                    pkce: true,
                    issuer: sampleConfig.oidc.issuer,
                    display: 'page',
                    scopes: sampleConfig.oidc.scopes,
                    responseType: ['id_token', 'token']
                },
                features: {
                    rememberMe: false,
                    passwordlessAuth: self.enableMfa,
                    showPasswordToggleOnSignInPage: true
                }
            });

            // have to do this for re-render when navigating back from forgot password
            self.widget.remove();

            self.widget.renderEl(
                {el: '#okta-signin-container'},
                async (res) => {
                    await self.handleLogin(res);
                },
                (err) => {
                    throw err;
                }
            );

            self.widget.on('ready', (context) => {
                document.querySelector('[name="username"]').addEventListener('blur', (e)=>{
                    this.setUsername(e.target.value);
                });
                document.querySelector('[type="submit"]').addEventListener('click', ()=>{
                    // attempt to apply shadowdom values to the input fields on some devices
                    if (document.querySelector('[name="password"]')) {
                        document.querySelector('[name="password"]').focus();
                    }
                    if (document.querySelector('[name="username"]')) {
                        document.querySelector('[name="username"]').focus();
                    }
                });
                document.getElementsByClassName('auth-footer').forEach((node) => node.remove());

                document.querySelector('#okta-signin-submit').addEventListener('click', (e) => {
                    if (document.querySelector('.okta-form-infobox-error') != null) {
                        if (self.tryGigya) {
                            self.initGigyaLogin();
                        }
                    }
                });

                // this.removeAutocomplete();
            });

            self.widget.on('afterError', (context, error) => {
                if (self.tryGigya) {
                    self.initGigyaLogin();
                } else {
                    self.handleOnError();
                }
            });
        });
    }
    // mounted() {
    //     this._setTranslations();
    // },
};
</script>

<style lang="scss">
@use "sass:map";
@import "~@nuskin/ns-core-styles/src/scss/buttons";
@import "~@nuskin/ns-core-styles/src/scss/colors";
@import "~@nuskin/ns-core-styles/src/scss/other";

.member-signup {
    .forgot-password-link {
        display: flex;
        position: relative;
        // margin-top: -96px;
        bottom:100px;
    }
}

#formError {
    text-align-last: left;
    padding-bottom: 20px;
    position: absolute;
    margin-top: -74px;
}

#formError p {
    color: #b2140a;
}

#forgotPasswordAnchor {
    margin: 0px !important;
}

#okta-sign-in {
    .o-form-head {
        display: none;
    }
    .o-form-fieldset {
        margin-top: 4px;
        margin-bottom: 24px;
    }
}

#okta-sign-in .o-form-input-name-answer {
    height: 45px;
}

#okta-sign-in .auth-content {
    &:focus {
        border: none;
    }
}

#okta-sign-in.auth-container .button-primary {
    width: 100%;
    margin-top: 70px;
    color: #fff;
    background: -o-linear-gradient(top,#7123d9 0,#7123d9 100%);
    background: -ms-linear-gradient(top,#7123d9 0,#7123d9 100%);
    background: -webkit-gradient(linear,left top,left bottom,from(#7123d9),to(#7123d9));
    @extend %button-base;
    background-color: map.get($baseColors, "shells");
    border-color: map.get($baseColors, "shells");
    color: map.get($baseColors, "basewhite");

    &> i,
    &> i.v-icon {
        color: map.get($baseColors, "basewhite");
    }

    &:active {
        background-color: map.get($baseColors, "astronomy");
        border-color: map.get($baseColors, "astronomy");
        color: map.get($baseColors, "basewhite");
    }

    &:disabled,
    &:disabled:hover {
        background-color: map.get($themeColors, "color-primary-button-hit-disabled");
        border-color: map.get($themeColors, "color-primary-button-hit-disabled");
    }
}

#okta-sign-in.auth-container .btn-disabled {
    background: -o-linear-gradient(top,#9D6AE1 0,#9D6AE1 100%);
    background: -ms-linear-gradient(top,#9D6AE1 0,#9D6AE1 100%);
    background: -webkit-gradient(linear,left top,left bottom,from(#9D6AE1),to(#9D6AE1));
    background-color: #9D6AE1;
    border-color: #9D6AE1;
}

#okta-sign-in .o-form .input-fix input {
    border: 1px solid #63666a;
}

#okta-sign-in.auth-container.main-container {
    outline:none;
}

#okta-sign-in.auth-container .okta-form-input-field {
        height: 45px;
}

#showPasswordDiv {
  //  margin-top: -15px;
}

#okta-sign-in .link .help .js-help {
    display: none;
}

#okta-sign-in .primary-auth .auth-footer {
    display: none;
}

@media screen and (max-width: 768px) {
    #okta-sign-in.auth-container .okta-form-input-field {
        height: 45px;
    }
    #showPasswordDiv {
        top: 325px;
    }
}

@media (max-width: 480px) {
    #showPasswordDiv {
        top: 345px;
    }
}

#okta-sign-in .o-form label {
    float: left;
}

#okta-sign-in .o-form-edit-mode .o-form-content .o-form-error-container p{
    text-align: left;
    color: red;
}

.v-text-toggle__suffix {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    top: 335px;
    margin-right:10px;
}

#okta-sign-in.auth-container .o-form-explain.okta-form-input-error {
    // display: none;
    text-align: left;
    color:#b2140a;
}

.o-form-has-errors{
    input{
        border: 2px solid #b2140a !important;
    }
}
input[type="submit"] {
  height: 40px;
}
</style>
